import React from 'react'
import Footer from '../Footer'
import EduFour from '../EduFour'

function ImgthsOne() {
    window.scrollTo(0,0);
    return (
        <div>
            <EduFour/>
            <Footer/>
        </div>
    )
}

export default ImgthsOne
